import { render, staticRenderFns } from "./IconEnvelopeTimes.vue?vue&type=template&id=0604ff54"
import script from "./IconEnvelopeTimes.vue?vue&type=script&lang=js"
export * from "./IconEnvelopeTimes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports